(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
(function () {
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('[data-bigmat-collection-atc]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    document.querySelectorAll('.qty-error').forEach(function (error) { error.remove(); });

    var variantId = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    if (!variantId || !variantId.value) return;

    var quantity = parseInt(quantityInput && quantityInput.value, 10) || 1;
    window.location.assign('/cart/add?id=' + encodeURIComponent(variantId.value) + '&quantity=' + quantity + '&return_to=/cart');
  }, true);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-cart"]) return;
  try {
    
(function () {
  function getControl(target) { return target.closest('[data-bigmat-cart-quantity]'); }
  function getInput(control) { return control && control.querySelector('.bigmat-cart-quantity__input'); }
  function getMax(control) { var max = parseInt(control.getAttribute('data-max'), 10); return isNaN(max) ? 0 : max; }
  function normalize(value, max) { value = parseInt(value, 10); if (isNaN(value) || value < 1) value = 1; return max > 0 ? Math.min(value, max) : 0; }
  function setButtons(control, value) {
    var max = getMax(control);
    var minus = control.querySelector('[data-bigmat-cart-quantity-action="decrease"]');
    var plus = control.querySelector('[data-bigmat-cart-quantity-action="increase"]');
    if (minus) minus.disabled = value <= 1;
    if (plus) plus.disabled = max < 1 || value >= max;
  }
  function productName(control) {
    var row = control.closest('.cart__row');
    var title = row && row.querySelector('.cart__product-name');
    return title && title.textContent.trim() ? title.textContent.trim() : 'Ce produit';
  }
  function showStockLimit(control, max) {
    var existing = document.getElementById('BigmatStockLimitModal');
    if (existing) existing.remove();
    var unit = max > 1 ? 'pièces' : 'pièce';
    var modal = document.createElement('div');
    modal.id = 'BigmatStockLimitModal';
    modal.className = 'bigmat-stock-limit-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'BigmatStockLimitTitle');
    modal.innerHTML = '<div class="bigmat-stock-limit-modal__dialog"><h2 id="BigmatStockLimitTitle" class="bigmat-stock-limit-modal__title">Quantité limitée au stock disponible</h2><p class="bigmat-stock-limit-modal__text">' + productName(control) + ' ne peut pas être commandé dans la quantité demandée.</p><p class="bigmat-stock-limit-modal__availability">Il reste ' + max + ' ' + unit + ' disponible' + (max > 1 ? 's' : '') + '.</p><button type="button" class="bigmat-stock-limit-modal__button" data-bigmat-stock-limit-close>Mettre à jour mon panier</button></div>';
    function confirmLimit() {
      if (!modal.parentNode) return;
      modal.remove();
      update(control, max);
    }
    modal.addEventListener('click', function (event) {
      if (event.target === modal) confirmLimit();
    });
    modal.querySelector('[data-bigmat-stock-limit-close]').addEventListener('click', confirmLimit);
    document.body.appendChild(modal);
    modal.querySelector('[data-bigmat-stock-limit-close]').focus();
  }
  function update(control, requested) {
    var input = getInput(control);
    var max = getMax(control);
    if (!input || max < 1 || control.getAttribute('data-pending') === 'true') return;
    var entered = parseInt(requested, 10);
    if (!isNaN(entered) && entered > max) {
      input.value = max;
      setButtons(control, max);
      showStockLimit(control, max);
      return;
    }
    var quantity = normalize(requested, max);
    input.value = quantity;
    setButtons(control, quantity);
    control.setAttribute('data-pending', 'true');
    var form = input.closest('form');
    if (form) form.submit();
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bigmat-cart-quantity-action]');
    if (!button || button.disabled) return;
    event.preventDefault();
    var control = getControl(button), input = getInput(control);
    if (!control || !input) return;
    var current = normalize(input.value, getMax(control));
    update(control, current + (button.getAttribute('data-bigmat-cart-quantity-action') === 'increase' ? 1 : -1));
  });
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.bigmat-cart-quantity__input')) return;
    var control = getControl(event.target);
    update(control, event.target.value);
  });
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bigmat-cart-quantity]').forEach(function (control) {
      var input = getInput(control);
      if (!input) return;
      var max = getMax(control);
      var entered = parseInt(input.value, 10);
      var value = normalize(input.value, max);
      input.value = value;
      setButtons(control, value);
      if (!isNaN(entered) && entered > max && max > 0) showStockLimit(control, max);
    });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
(function () {
  function getMax(input) {
    var max = parseInt(input.getAttribute('max'), 10);
    return isNaN(max) || max < 1 ? null : max;
  }

  function clampQuantity(input) {
    var value = parseInt(input.value, 10);
    var max = getMax(input);
    if (isNaN(value) || value < 1) value = 1;
    if (max !== null) value = Math.min(value, max);
    input.value = value;
    var quantityControl = input.closest('[data-bigmat-quantity]');
    var output = quantityControl ? quantityControl.querySelector('[data-bigmat-quantity-value]') : null;
    if (output) output.textContent = value;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bigmat-quantity-button]');
    if (!button) return;
    var control = button.closest('[data-bigmat-quantity]');
    if (!control) return;
    var input = control.querySelector('input[name="quantity"]');
    if (!input) return;

    var current = parseInt(input.value, 10);
    var max = getMax(input);
    if (isNaN(current) || current < 1) current = 1;
    if (button.getAttribute('data-bigmat-quantity-button') === 'plus') {
      current = max === null ? current + 1 : Math.min(current + 1, max);
    } else {
      current = Math.max(1, current - 1);
    }
    input.value = current;
    var output = control.querySelector('[data-bigmat-quantity-value]');
    if (output) output.textContent = current;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-bigmat-quantity] input[name="quantity"]')) {
      clampQuantity(event.target);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-bigmat-quantity] input[name="quantity"]')) {
      clampQuantity(event.target);
    }
  });

  document.addEventListener('blur', function (event) {
    if (event.target.matches('[data-bigmat-quantity] input[name="quantity"]')) {
      clampQuantity(event.target);
    }
  }, true);
}());

  } catch(e) { console.error(e); }
})();
})();
